import Layout from '@/layout'

// 基本信息管理路由
const basicRoutes = {
  path: '/basic',
  component: Layout,
  redirect: '/basic/units',
  name: 'Basic',
  meta: { title: '基本信息', icon: 'el-icon-document', requiresAuth: true },
  children: [
    // 单位管理
    {
      path: 'units',
      name: 'UnitsList',
      component: () => import('@/views/basic/units-list'),
      meta: { title: '单位管理', requiresAuth: true }
    },
    {
      path: 'unit/:id',
      name: 'UnitInfo',
      component: () => import('@/views/basic/unit-info'),
      meta: { title: '单位详情', requiresAuth: true },
      hidden: true
    },
    
    // 用户管理
    {
      path: 'users',
      name: 'UsersList',
      component: () => import('@/views/basic/user-info'),
      meta: { title: '用户管理', requiresAuth: true }
    },
    
    // 项目用户管理（隐藏菜单，只能通过项目列表访问）
    {
      path: 'project-user-info',
      name: 'ProjectUserInfo',
      component: () => import('@/views/basic/project-user-info'),
      meta: { title: '项目用户管理', requiresAuth: true, hidden: true }
    },
    
    // 项目管理（隐藏菜单，只能通过按钮访问）
    {
      path: 'projects',
      name: 'ProjectsList',
      component: () => import('@/views/basic/projects-list'),
      meta: { title: '项目管理', requiresAuth: true, hidden: true }
    },
    
    // 客户管理
    {
      path: 'customers',
      name: 'CustomersList',
      component: () => import('@/views/basic/customer-info'),
      meta: { title: '客户管理', requiresAuth: true }
    },
    
    // 供应商管理
    {
      path: 'suppliers',
      name: 'SuppliersList',
      component: () => import('@/views/basic/supplier-info'),
      meta: { title: '供应商管理', requiresAuth: true }
    },
    
    // 客户项目
    {
      path: 'customer-projects',
      name: 'CustomerProjects',
      component: () => import('@/views/basic/customer-projects'),
      meta: { title: '客户项目', requiresAuth: true }
    },

    // 产品管理（支持 /basic/products 和 /basic/product-management 两种路径）
    {
      path: 'products',
      name: 'ProductManagement',
      component: () => import('@/views/basic/product-management'),
      meta: { title: '产品管理', requiresAuth: true }
    },
    {
      path: 'product-management',
      name: 'ProductManagementAlt',
      component: () => import('@/views/basic/product-management'),
      meta: { title: '产品管理', requiresAuth: true }
    }
  ]
}

export default basicRoutes
